export default [
  {
    path: '/applications',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "application-list" */ "@/views/applications/List.vue"),
  }, {
    path: '/applications/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "application" */ "@/views/applications/Application.vue"),
  }
]
